export const endPoints = {
  BOSS_MONTHLY_PAYMENTS: '/v1/contract/monthly-payment/boss',
  HOUSES: '/v1/house/compact-payment'
};
